import { useCMS } from '../../../contexts/CMSContext';
import EditableText from '../../../components/cms/EditableText';
import EditableImage from '../../../components/cms/EditableImage';

export default function HeroSection() {
  const { data } = useCMS();
  const { hero } = data;

  const handleCTA = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.querySelector('#agendar')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="inicio" className="relative min-h-screen bg-[#1A1A1A] overflow-hidden flex items-center">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=abstract%20organic%20shapes%20leaves%20nature%20pattern%20dark%20background%20green%20botanical%20minimalist%20texture%20wellness%20health%20concept%20artistic&width=1400&height=900&seq=hero_bg_v1&orientation=landscape)',
        }}
      />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-28 pb-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div className="flex flex-col items-start text-left gap-6">
          <span className="inline-flex items-center gap-2 bg-[#8B9D83]/20 border border-[#8B9D83]/40 text-[#8B9D83] text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full">
            <span className="w-1.5 h-1.5 bg-[#8B9D83] rounded-full inline-block"></span>
            <EditableText section="hero" field="badge" tag="span" className="text-xs" />
          </span>

          <div className="flex flex-col gap-1">
            <EditableText
              section="hero"
              field="title1"
              tag="h1"
              className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-semibold text-white leading-tight"
            />
            <EditableText
              section="hero"
              field="title2"
              tag="h2"
              className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-semibold text-[#8B9D83] leading-tight"
            />
          </div>

          <EditableText
            section="hero"
            field="subtitle"
            tag="p"
            multiline
            className="text-stone-400 text-lg leading-relaxed max-w-lg"
          />

          <div className="flex items-center gap-3 flex-nowrap">
            <a
              href="#agendar"
              onClick={handleCTA}
              className="inline-flex items-center gap-2 bg-[#8B9D83] text-white font-semibold px-4 py-3 sm:px-7 sm:py-4 rounded-full hover:bg-[#6B7D63] transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-calendar-check-line text-base"></i>
              </div>
              <EditableText section="hero" field="ctaText" tag="span" className="text-sm font-semibold" />
            </a>
            <a
              href="#servicios"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#servicios')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 border border-white/30 text-white font-medium px-4 py-3 sm:px-6 sm:py-4 rounded-full hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              <EditableText section="hero" field="secondaryCtaText" tag="span" className="text-sm font-medium" />
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </a>
          </div>

          <div className="mt-2 pt-6 border-t border-white/10 w-full lg:hidden" />
        </div>

        <div className="flex justify-center items-end h-full">
          <div className="relative w-[280px] h-[380px] lg:w-[420px] lg:h-[560px]">
            <div className="absolute inset-0 rounded-3xl bg-[#8B9D83]/10 border border-[#8B9D83]/20"></div>
            <EditableImage
              imageKey="hero_photo"
              alt={hero.nutritionistName || 'Nutricionista'}
              wrapperClassName="w-full h-full rounded-3xl overflow-hidden"
              className="w-full h-full object-cover object-top rounded-3xl"
            />
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-t from-[#1A1A1A]/60 via-transparent to-transparent pointer-events-none" />
          </div>
        </div>
      </div>

      <a
        href="#servicios"
        onClick={(e) => {
          e.preventDefault();
          document.querySelector('#servicios')?.scrollIntoView({ behavior: 'smooth' });
        }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50 hover:text-white/80 transition-colors cursor-pointer"
      >
        <EditableText section="hero" field="scrollHintText" tag="span" className="text-xs uppercase tracking-widest" />
        <div className="w-5 h-5 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-line text-base"></i>
        </div>
      </a>
    </section>
  );
}
